'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOADING = exports.LOADING = 'LOADING';
var SUCCESS = exports.SUCCESS = 'SUCCESS';
var WARNING = exports.WARNING = 'WARNING';
var ERROR = exports.ERROR = 'ERROR';
var ACTION_MESSAGE = exports.ACTION_MESSAGE = 'ACTION_MESSAGE';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-core/feedback-snackbar/FeedbackSnackbarTypes.js
// module id = 857
// module chunks = 0